module.exports = __webpack_public_path__ + "static/concept-banner-d89523aca6e43c62caa6908002bc329c.svg";